module.exports = __webpack_public_path__ + "static/media/plantd.a769e5cc.png";